import * as $ from "jquery";
import * as ko from "knockout";

// Models
import { TooltipOptionOverrides } from "Content/ts/Models/Bootstrap/TooltipsPopovers/tooltipConfiguration";

// Services
import { FontAwesomeServices } from "Content/ts/Shared/KnockoutBindings/Services/fontAwesomeServices";

export namespace TooltipServices {
    export function ConfigureStandardTooltip(element: Element, allbindings: TooltipOptionOverrides, value: string | KnockoutObservable<string>, allowHtml: boolean): void {
        (<any>$(element)).tooltip({
            html: allowHtml,
            title: ko.unwrap(value),
            trigger: "hover",
            placement: allbindings.placement ? allbindings.placement : "left"
        });
    }

    export function InformationIconMarkup(value: string | KnockoutObservable<string>): string {
        return `
            <div class="sr-only">${ko.unwrap(value)}</div>
            ${FontAwesomeServices.InfoCircleTooltip()}
        `;
    }
}
